import { render, staticRenderFns } from "./Collaborators.vue?vue&type=template&id=298f6472&scoped=true&"
import script from "./Collaborators.vue?vue&type=script&lang=ts&"
export * from "./Collaborators.vue?vue&type=script&lang=ts&"
import style0 from "./Collaborators.vue?vue&type=style&index=0&id=298f6472&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298f6472",
  null
  
)

export default component.exports